import clsx from "clsx";
import React from "react";

type TextSizeType =
  | "xs"
  | "sm"
  | "base"
  | "lg"
  | "xl"
  | "2xl"
  | "3xl"
  | "4xl"
  | "5xl"
  | "6xl"
  | "7xl"
  | "8xl"
  | "9xl";

type TextPlaceholderProps = {
  size?: TextSizeType;
  className?: string;
};

const TextHeightHashmap = {
  xs: "h-4",
  sm: "h-5",
  base: "h-6",
  lg: "h-7",
  xl: "h-7",
  "2xl": "h-8",
  "3xl": "h-9",
  "4xl": "h-12",
  "5xl": "h-14",
  "6xl": "h-16",
  "7xl": "h-20",
  "8xl": "h-24",
  "9xl": "h-32",
};

const TextPlaceholder = (props: TextPlaceholderProps) => {
  const { size = "base", className = "w-full" } = props;

  return (
    <div
      className={clsx(
        `${TextHeightHashmap[size]} bg-gray-200 rounded-full animate-pulse`,
        className,
      )}
    />
  );
};

export default TextPlaceholder;
